import { useTranslation } from "react-i18next";
import Container from "react-bootstrap/esm/Container";
import { Link } from "react-router";
import { Globals } from "../globals";

export default function Nutzungsbedingungen() {
    const { t } = useTranslation();

    return (
        <Container className="py-4">
            <h1>{t('footer.terms')}</h1>
            <p className="text-muted">{t('legal.lastUpdated')}: 01.01.2025</p>

            <h2 className="h4 mt-4">{t('legal.terms.section1Title')}</h2>
            <p>{t('legal.terms.section1Text')}</p>

            <h2 className="h4 mt-4">{t('legal.terms.section2Title')}</h2>
            <p>{t('legal.terms.section2Text')}</p>

            <h2 className="h4 mt-4">{t('legal.terms.section3Title')}</h2>
            <p>{t('legal.terms.section3Text1')}</p>
            <p>{t('legal.terms.section3Text2')}</p>

            <h2 className="h4 mt-4">{t('legal.terms.section4Title')}</h2>
            <p>{t('legal.terms.section4Text')}</p>

            <h2 className="h4 mt-4">{t('legal.terms.section5Title')}</h2>
            <p>{t('legal.terms.section5Text')}</p>

            <h2 className="h4 mt-4">{t('legal.terms.section6Title')}</h2>
            <p>{t('legal.terms.section6Text')}</p>

            <h2 className="h4 mt-4">{t('legal.terms.section7Title')}</h2>
            <p>
                {t('legal.terms.section7Text')}{' '}
                <Link to={Globals.PATH_DATENSCHUTZ}>{t('footer.privacy')}</Link>.
            </p>

            <h2 className="h4 mt-4">{t('legal.terms.section8Title')}</h2>
            <p>{t('legal.terms.section8Text')}</p>

            <h2 className="h4 mt-4">{t('legal.terms.section9Title')}</h2>
            <p>{t('legal.terms.section9Text')}</p>
            <p>
                {t('legal.terms.contactInfo')}: <a href={`mailto:${Globals.ADMIN_EMAIL}`}>{Globals.ADMIN_EMAIL}</a>
            </p>
        </Container>
    );
}
